import MFAPanel from '../../components/Security/MFAPanel';
import AccountDataPanel from '../../components/Security/AccountDataPanel';
import styles from './SecurityPage.module.css';

export default function SecurityPage() {
  return (
    <div className={styles.page}>
      <MFAPanel />
      <hr className={styles.divider} />
      <AccountDataPanel />
    </div>
  );
}
